var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","top":"0"}},[_c('img',{staticClass:"full_w",attrs:{"src":require("@/images/theme11.jpeg")}}),_vm._v(" "),_c('router-link',{attrs:{"to":"home"}},[_c('button',{staticStyle:{"position":"absolute","top":"32rem","left":"17rem","width":"5rem","height":"5rem","background-color":"transparent"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77e75963","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/home/home11.vue
// module id = null
// module chunks = 